export default "__VITE_ASSET__ifPGnL03__"